// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Proportional pie chart maps */

/*   muted country boundaries */
.em--pie .em-cntbn {
    stroke: grey;
}

/*   muted nuts boundaries */
.em--pie .em-bn-1,
.em--pie .em-bn-2,
.em--pie .em-bn-3,
.em--pie .em-nutsrg [lvl='3'],
.em--pie .em-nutsrg [lvl='2'],
.em--pie .em-nutsrg [lvl='1'],
.em--pie .em-bn-co {
    stroke-width: 0.07px;
}

/*  muted country fill */
.em--pie .em-cntrg {
    fill: #f2f2f2;
}

/*  nuts fill (regions with data) */
.em--pie .em-nutsrg {
    fill: #fffeef;
}

/*  regions without data input */
.em--pie [ecl='ni'] {
    fill: #f2f2f2;
}

/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */
/* .em--pie g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {
    stroke-width: 0px;
} */

/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */
.em--pie .em-bn-co {
    stroke: grey;
    stroke-width: 0.2px;
}

.em--pie #em-cntbn-halo {
    stroke: none;
}
`, "",{"version":3,"sources":["webpack://./src/css/map-types/pie.css"],"names":[],"mappings":"AAAA,gCAAgC;;AAEhC,+BAA+B;AAC/B;IACI,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;;;;;;;IAOI,oBAAoB;AACxB;;AAEA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA,mCAAmC;AACnC;IACI,aAAa;AACjB;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,uHAAuH;AACvH;;GAEG;;AAEH,0HAA0H;AAC1H;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* Proportional pie chart maps */\r\n\r\n/*   muted country boundaries */\r\n.em--pie .em-cntbn {\r\n    stroke: grey;\r\n}\r\n\r\n/*   muted nuts boundaries */\r\n.em--pie .em-bn-1,\r\n.em--pie .em-bn-2,\r\n.em--pie .em-bn-3,\r\n.em--pie .em-nutsrg [lvl='3'],\r\n.em--pie .em-nutsrg [lvl='2'],\r\n.em--pie .em-nutsrg [lvl='1'],\r\n.em--pie .em-bn-co {\r\n    stroke-width: 0.07px;\r\n}\r\n\r\n/*  muted country fill */\r\n.em--pie .em-cntrg {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/*  nuts fill (regions with data) */\r\n.em--pie .em-nutsrg {\r\n    fill: #fffeef;\r\n}\r\n\r\n/*  regions without data input */\r\n.em--pie [ecl='ni'] {\r\n    fill: #f2f2f2;\r\n}\r\n\r\n/* Hide non-nuts borders (country boundaries > that are 'other' and not coastal, not candidates, not eu and not efta) */\r\n/* .em--pie g#em-cntbn > .em-bn-oth:not(.em-bn-co):not(.em-bn-cc):not(.em-bn-eu):not(.em-bn-efta) {\r\n    stroke-width: 0px;\r\n} */\r\n\r\n/* Coastlines should not be drawn for choropleths, however for prop symbol maps with white regions they can be necessary */\r\n.em--pie .em-bn-co {\r\n    stroke: grey;\r\n    stroke-width: 0.2px;\r\n}\r\n\r\n.em--pie #em-cntbn-halo {\r\n    stroke: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
